import location from './location';
import params from './params';

export function facebookShare(link) {
    link = (link && typeof link == "string")?link:location();
    window.open('https://www.facebook.com/sharer/sharer.php?u='+ link, 'facebookwindow', params);
};